import React, { useState } from 'react';
import { toast } from 'react-toastify';
import ImageModal from '../ImageModal';
import { validateImageFile } from '../../utils/fileValidation';

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(5, 1fr)',
  gap: '20px',
  marginTop: '20px',
};

const cardStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '10px',
  border: '1px solid #ddd',
  borderRadius: '8px',
  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  backgroundColor: '#f9f9f9',
};

const thumbStyle = {
  width: '100%',
  height: 'auto',
  maxWidth: '150px',
  maxHeight: '150px',
  cursor: 'pointer',
  marginBottom: '10px',
};

const deleteBtnStyle = {
  backgroundColor: '#ff4d4f',
  color: 'white',
  border: 'none',
  padding: '8px 12px',
  cursor: 'pointer',
  borderRadius: '5px',
  fontSize: '14px',
};

const GalleriaTab = ({
  galleria,
  loading,
  error,
  onUpload,
  onDelete,
}) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleUpload = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    const validFiles = [];
    for (const file of files) {
      const { valid, error: validationError } = validateImageFile(file);
      if (!valid) {
        toast.error(`${file.name}: ${validationError}`);
        continue;
      }
      validFiles.push(file);
    }

    if (validFiles.length > 0) onUpload(validFiles);
    e.target.value = '';
  };

  return (
    <div>
      <div>
        <label htmlFor="gallery-upload">Carica immagini per la galleria:</label>
        <input
          id="gallery-upload"
          type="file"
          accept="image/*"
          multiple
          onChange={handleUpload}
        />
      </div>

      <div style={gridStyle}>
        {loading && <p>Caricamento...</p>}
        {!loading && error && <p>{error}</p>}
        {!loading && !error && galleria.length === 0 && <p>Nessuna immagine in galleria.</p>}
        {!loading &&
          !error &&
          galleria.map((img) => (
            <div key={img.idImmagine} style={cardStyle}>
              <img
                src={img.image}
                alt={img.nomeFile}
                style={thumbStyle}
                onClick={() => setSelectedImage(img.image)}
                loading="lazy"
              />
              <p style={{ margin: '5px 0', textAlign: 'center', fontWeight: 'bold' }}>
                {img.nomeFile}
              </p>
              <button
                type="button"
                style={deleteBtnStyle}
                onClick={() => onDelete(img.idImmagine)}
                aria-label={`Cancella ${img.nomeFile}`}
              >
                Cancella
              </button>
            </div>
          ))}
      </div>

      <ImageModal
        image={selectedImage}
        isOpen={Boolean(selectedImage)}
        onClose={() => setSelectedImage(null)}
      />
    </div>
  );
};

export default GalleriaTab;
